import { Farsi } from './farsi'

export const Localization = {
    Farsi: Farsi
}